module.exports = __webpack_public_path__ + "static/media/exposure-increase.cc339a3f.svg";